/** @jsxImportSource @emotion/react */

import React from "react";
import { css } from "@emotion/react";
import { Flex, Box } from "reflexbox";
import { PresetButton } from "./PresetButton";

export function PresetGroup({ presets, SelectedPresetsState }) {
	return (
		<Box pb={3}>
			<strong>Presets</strong>
			<Flex
				css={css`
					font-size: 8pt;
				`}
				justifyContent="center"
				mb={2}
				flexWrap="wrap"
			>
				{presets.map((preset) => {
					return (
						<PresetButton
							SelectedPresetsState={SelectedPresetsState}
							preset={preset}
						/>
					);
				})}
			</Flex>
			<hr />{" "}
		</Box>
	);
}
